import { useTranslation } from '@crehana/i18n';

import { type TKeys, WHATSAPP_TEMPLATES_PAGE_KEY } from '../i18n';
import { useAddResourceBundleWhatsappTemplates } from './use-add-resource-bundle';

export const useWhatsappTemplatesTranslations = () => {
  useAddResourceBundleWhatsappTemplates();
  return useTranslation<TKeys>(WHATSAPP_TEMPLATES_PAGE_KEY);
};
